import type { User } from "@data-root/types";

export function userFromMetadata(meta: Record<string, unknown> | null | undefined): User | null {
  if (!meta || typeof meta.id !== "string") return null;
  const id = meta.id;
  let name = "";
  if (typeof meta.name === "string") name = meta.name;
  else if (typeof meta.email === "string") name = meta.email;
  const email = typeof meta.email === "string" ? meta.email : "";
  let permissions: string[] = [];
  if (Array.isArray(meta.permissions)) {
    permissions = (meta.permissions as string[]).filter((p) => typeof p === "string");
  } else if (typeof meta.role === "string") {
    permissions = [meta.role];
  }
  return { id, name, email, permissions };
}
